<app-header></app-header>
<section class="showcase-area" id="showcase">
  <div class="showcase-container">
    <h1 class="main-title blue" id="home" style="font-weight: bolder;text-shadow: 3px 3px 3px white;">¿Buscás aparta?</h1>
    <p style="text-shadow: 3px 3px 3px white;">Hablemos</p>
    <a href="https://calendly.com/voy-jaleas/30min?month=2023-02" target="blank" class="btn btn-primary blue-btn">Reservar videollamada gratis</a>
  </div>
</section>

<section id="about">
  <div class="about-wrapper container">
    <div class="about-text">
      <p class="small">Alquiler y Vivienda</p>
      <h2 class="blue flex-column">Encuentra tu hogar ideal</h2>
        <p style="margin: 1rem 0;">En VoyJaleas, entendemos que encontrar el lugar ideal para vivir puede ser un desafío, especialmente desde el extranjero. Por eso, estamos aquí para guiarte en cada paso del camino.</p>
        <p>Con años de experiencia y una amplia red de contactos en las principales ciudades españolas, nuestro equipo te ofrece asesoría personalizada para hallar ese lugar que llamarás hogar.</p>
    </div>
    <div class="about-img">
      <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/d1234641-0ac8-4b36-9de6-04221f7a2400/public" alt="food" />
    </div>
  </div>
</section>

<section id="food">
  <h2 class="blue">Beneficios</h2>
  <ul class="center margin-2rem">
    <li>Asesoría personalizada basada en tus necesidades y presupuesto.</li>
    <li>Recomendaciones de zonas según precio y necesidades</li>
    <li>Soporte en todo el proceso: desde la búsqueda hasta la firma del contrato.</li>
    <li>Consejos expertos sobre la vida en España.</li>
    <li>Asesoramiento para evitar estafas</li>
  </ul>
  <div class="food-container container">
    <div class="food-type fruite">
      <div class="img-container">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/9cfc7982-71d0-4cbe-f084-d802e98f4d00/public" alt="error" />
        <div class="img-content">
          <h3>Videollamada Gratis</h3>
          <a
            href="https://calendly.com/voy-jaleas/30min?month=2023-02"
            class="btn btn-primary blue-btn"
            target="blank"
            >Reservar</a
          >
        </div>
      </div>
      <h4 class="center margin-2rem">Zonas y precios de referencia</h4>
    </div>
    <p></p>
    <div class="food-type vegetable">
      <div class="img-container">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/ff539e75-a3b1-4fef-2e86-9226c1d91700/public" alt="error" />
        <div class="img-content">
          <h3>Videollamada Gratis</h3>
          <a
            href="https://calendly.com/voy-jaleas/30min?month=2023-02"
            class="btn btn-primary blue-btn"
            target="blank"
            >Reservar</a
          >
        </div>
      </div>
      <h4 class="center margin-2rem">Condiciones contrato y garantías</h4>
    </div>
    <div class="food-type grin">
      <div class="img-container">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/6b28145f-598e-428d-1535-d81ee3081900/public" alt="error" />
        <div class="img-content">
          <h3>Videollamada Gratis</h3>
          <a
            href="https://calendly.com/voy-jaleas/30min?month=2023-02"
            class="btn btn-primary blue-btn"
            target="blank"
            >Reservar</a
          >
        </div>
        <h4></h4>
      </div>
      <h4 class="center margin-2rem">Plataformas de búsqueda</h4>
    </div>
  </div>
</section>

<app-footer-landing></app-footer-landing>